export const formatCurrency = (amount) => {
    if (isNaN(amount) || amount === undefined) {
      return 'AED 0.00';
    }
    return new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
  };